import Action from '../action';

// Asset population from repository (search results)
export const ASSETS_FAILED_TO_POPULATE = 'ASSETS_FAILED_TO_POPULATE';

// Asset manipulation
export const ASSETS_SELECTED = 'ASSETS_SELECTED';
export const ASSET_VIEWED = 'ASSET_VIEWED';

// Pagination
export const PAGESIZE_UPDATED = 'PAGESIZE_UPDATED';
export const PAGE_SELECTED = 'PAGE_SELECTED';

export const updatePageSize = value => Action(PAGESIZE_UPDATED, value);
export const failToPopulate = message => Action(ASSETS_FAILED_TO_POPULATE, message);
export const select = assets => Action(ASSETS_SELECTED, assets);
export const viewed = asset => Action(ASSET_VIEWED, asset);
export const selectPage = page => Action(PAGE_SELECTED, page);
export const resetLastViewedAsset = () => Action(ASSET_VIEWED, {id: ''});
